import { useTranslation } from 'react-i18next';

import { ReactComponent as CheckIcon } from '../../../../../../../assets/icons/check.svg';
import type { ICommercialPlanBundle } from '../../../../../../../shared/interfaces/quotes';
import { TRANSLATIONS_QUOTES } from '../../../../../../../shared/translations/quotes';
import { formatCurrency } from '../../../../../../../shared/utils/currency/currency';
import './PlanSummary.scss';

interface IPlanSummaryProps {
  bundle: ICommercialPlanBundle;
}

const INCLUSIONS_SEPARATOR = ',';

const splitInclusions = (description: string | null): string[] =>
  description
    ? description
        .split(INCLUSIONS_SEPARATOR)
        .map((item) => item.trim())
        .filter(Boolean)
    : [];

const PlanSummary = ({ bundle }: IPlanSummaryProps) => {
  const { t } = useTranslation();
  const PLAN_SELECTION = TRANSLATIONS_QUOTES.create.planSelection;
  const inclusions = splitInclusions(bundle.description);

  return (
    <section className="plan-summary" aria-label={t(PLAN_SELECTION.quotedPlan)}>
      <header className="plan-summary__head">
        <div className="plan-summary__identity">
          <div className="plan-summary__eyebrow">{t(PLAN_SELECTION.quotedPlan)}</div>
          <h3 className="plan-summary__name">{bundle.name}</h3>
        </div>
        <div className="plan-summary__price">
          <span className="plan-summary__price-amount">
            {bundle.suggestedPrice != null ? formatCurrency(bundle.suggestedPrice) : '—'}
          </span>
          <span className="plan-summary__price-unit">{t(PLAN_SELECTION.perEmployeeMonth)}</span>
        </div>
      </header>

      {inclusions.length > 0 && (
        <div className="plan-summary__body">
          <div className="plan-summary__body-label">{t(PLAN_SELECTION.whatsIncluded)}</div>
          <ul className="plan-summary__inclusions">
            {inclusions.map((item) => (
              <li key={item} className="plan-summary__inclusion">
                <CheckIcon className="plan-summary__check" aria-hidden="true" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}
    </section>
  );
};

export default PlanSummary;
